@if(appInitialized){
    <p-toast position="top-center" [breakpoints]="{ '1024px': { width: 'calc(100% - 2rem)', left: '1rem', right: '1rem', transform: 'none' } }"></p-toast>
    <!-- App-level prompt used by ConfirmService and UnsavedChangesService -->
    <p-confirmdialog key="app" [style]="{ width: '28rem' }" [breakpoints]="{ '640px': '95vw' }"></p-confirmdialog>
    <router-outlet></router-outlet>
}